module.exports = __webpack_public_path__ + "img/w3_circle_dark.98b2f310.png";